// extracted by css-extract-rspack-plugin
export default {"info":"ValuesSourceTypeModal-module__info___GE2Cb","icon":"ValuesSourceTypeModal-module__icon___ubdek"};